import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IAdjuster } from '../../../models/adjuster';
import { CardModule } from 'primeng/card';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { ButtonGroupModule } from 'primeng/buttongroup';
import { TealCompReferralSubmission } from '../../../models/teal-comp-referral';
import { ReferralState } from '../../../state/referrals/referral-state';
import { Store } from '@ngxs/store';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-adjuster-editor',
  standalone: true,
  imports: [CardModule,FloatLabelModule,InputTextModule,FormsModule,ButtonModule,ButtonGroupModule, NgIf],
  templateUrl: './adjuster-editor.component.html',
  styleUrl: './adjuster-editor.component.scss'
})
export class AdjusterEditorComponent 
{
  @Input() adjuster:IAdjuster = {} as IAdjuster;
  @Output() saved: EventEmitter<IAdjuster> = new EventEmitter<IAdjuster>();
  @Output() cancelled = new EventEmitter();

  //Listen for whether the user has selected a referral to work with
  selectedReferral$ = this._store.select(ReferralState.currentReferral);
  activeSubmission?: TealCompReferralSubmission;


  constructor(private _store: Store)
  {
    this.selectedReferral$.subscribe
    (
      referral =>
        {
          this.activeSubmission = referral?.submission;
        }
    )
  }

  saveButtonPressed(event: MouseEvent)
  {
    this.saved.emit(this.adjuster);
  }

  cancelButtonPressed(event: MouseEvent)
  {
    this.cancelled.emit();
  }

  allowSave() : boolean
  {
    return this.adjuster.firstName != "" && this.adjuster.firstName != null && this.adjuster.lastName != null && this.adjuster.lastName != "" && this.adjuster.emailAddress != null && this.adjuster.emailAddress != "";
  }  
  
  fillFromSubmission()
  {
    if(this.activeSubmission)
    {

      this.adjuster.firstName = this.activeSubmission.adjusterFirstName;
      this.adjuster.lastName = this.activeSubmission.adjusterLastName;
      this.adjuster.emailAddress = this.activeSubmission.adjusterEmail;
      this.adjuster.phoneNumber = this.activeSubmission.adjusterPhone;
    }
  }

  clearForm()
  {
    this.adjuster = {} as IAdjuster;
  }
}
